import { Input, Text } from "@chakra-ui/react";

const smallUppercaseWithletterSpace = {
  fontWeight: "800",
  fontSize: "8px",
  lineHeight: "16px",
  color: "#0E3665",
  fontFamily: "Nunito",
  textTransform: "uppercase",
  letterSpacing: "2px",
};

const inputTextStyle = {
  width: "100%",
  height: "38px",
  border: "1px solid #ECEFF9",
  borderRadius: "4px",
  fontWeight: "700",
  fontSize: "13px",
  lineHeight: "22px",
  color: "#0E3665",
  fontFamily: "Nunito",
  marginTop: "8px",
  backgroundColor: "#D9D9D933",
};

const BookingDateForm = ({ currentBookingDate, selectedSlot }) => {
  return (
    <>
      <Text {...smallUppercaseWithletterSpace} marginTop={"55px"}>
        Booking Date
      </Text>
      <Input {...inputTextStyle} value={currentBookingDate} disabled />

      <Text {...smallUppercaseWithletterSpace} marginTop={"16px"}>
        Booking Slot
      </Text>
      <Input {...inputTextStyle} value={selectedSlot} disabled />
    </>
  );
};

export default BookingDateForm;
